import { TCreateSendMethod } from '../../../types/createSendFlow';

export const SET_CS_METHOD = 'SET_CS_METHOD';

export const setCreateSendMethod = (payload: TCreateSendMethod | null) => ({
  type: SET_CS_METHOD,
  payload,
});
